<template lang="html">
  <v-list class="pt-5">
    <v-list-group
      v-for="item in items"
      :value="item.active"
      :key="item.title"
      v-model="item.active"
      :class="!item.items ? 'no-child' : ''"
    >
      <v-list-tile slot="activator" :to="item.linkTo" active-class="active-nav">
        <v-list-tile-action>
          <v-icon :color="item.color">{{ item.action }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ item.title }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <!-- Rendering child list item -->
      <v-list-tile v-if="item.items" v-for="subItem in item.items" :key="subItem.title" :to="subItem.linkTo">
        <v-list-tile-content>
          <v-list-tile-title>
            {{ subItem.title }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>
  </v-list>
</template>

<script>
import items from './navData'
export default {
  data () {
    return {
      items
    }
  }
}
</script>

<style lang="css" scoped>
  .v-list >>> .v-list__tile {
    height: 50px;
  }
  .v-list >>> .no-child .v-list__group__header__append-icon {
    display: none;
  }
  .v-list >>> .primary--text.list__tile--active.list__tile.list__tile--link {
    color: #333 !important;
  }
  .v-list >>> .v-list__group__items > div:first-child{
    margin-top: 7px;
  }
  .v-list >>> .v-list__group__items .v-list__tile {
    height: 35px;
    outline: none;
    padding-left: 40px !important;
  }
  .v-list >>> .v-list__tile__title {
    font-size: 13px !important;
    font-weight: 500;
    color: #565656;
  }
  .dark-theme .v-list >>> .v-list__tile__title {
    color: #fff;
  }
  .v-list >>> .v-list__group__items .v-list__tile__title {
    font-size: 13px;
    font-weight: 400;
    color: #666;
  }
  .v-list >>> .v-list__group .v-list__tile:hover {
    color: #222;
    background: transparent !important;
  }
  .v-list >>> .v-list__group__items .v-list__tile__title:before{
    content: '●';
    display: inline-block;
    font-size: 9px;
    transform: translateY(-1px);
    margin-right: 10px;
  }
  .v-list >>> .v-list__group .v-list__tile.v-list__tile--active{
    background: transparent !important;
  }
  .v-list >>> .v-list__group .v-list__tile .v-list__tile__title:hover,
  .v-list >>> .v-list__group .router-link-exact-active .v-list__tile__title {
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
    transition: .3s cubic-bezier(.25,.8,.5,1);
  }
  .v-list >>> .v-list__group .v-list__tile--active .v-list__tile__title,
  .v-list >>> .v-list__group .v-list__tile--active .v-list__tile__title {
    color: #333;
  }
  .v-list >>> .v-list__group:after, .v-list__group:before{
    content: none;
  }
  .v-list >>> .v-list__tile--active, .v-list >>> .v-list__tile--link{
  }
  .v-list >>> .v-list__tile--active, .v-list >>> .v-list__tile--link:hover,
  .v-list >>> .v-list__group__header:hover {
    background: transparent;
  }
  .v-list >>> .v-list__tile {
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }
  .v-list >>> .v-list__tile:hover {
    padding-left: 20px;
  }
  .v-list >>> .v-list__group__header{
    border-radius: 3px;
  }
  .v-list__group__header>div:not(.v-list__group__header__prepend-icon):not(.v-list__group__header__append-icon) {
    overflow: initial;
  }
  .v-list >>> .v-list__group__header--active{
    background: transparent;
  }
  .v-list >>> .v-list__group__header--active:hover{
    background: transparent;
  }
  .v-list >>> .v-list__group__header--active .v-list__tile,
  .v-list >>> .v-list__group__header .v-list__tile {
    font-weight: 400;
    background: transparent !important;
  }
  .v-list >>> .v-list__group__header--active .v-list__tile,
  .v-list >>> .v-list__group__header>li:first-child:hover {
    background: transparent !important;
  }
  .v-list >>> .v-list__tile__action, .v-list__tile__avatar {
    min-width: 37px;
  }
  .v-list >>> .v-list__tile__action i{
    font-size: 20px;
    color: #565656;
  }
  .dark-theme .v-list >>> .v-list__tile__action i{
    color: #fff !important;
  }
  .v-list >>> .v-list__tile__title {
    font-size: 14px;
  }
  .v-list >>> .v-list__group__header__append-icon i{
    font-size: 20px;
  }
  .v-list >>> .v-list__group__header{
    -webkit-transition: .3s cubic-bezier(.25,.8,.5,1);
    transition: .3s cubic-bezier(.25,.8,.5,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/sidebar/navs.vue